import CancelSub from "../../../../src/assets/subscriptions/cancel-sub.png";
import PauseSub from "../../../../src/assets/subscriptions/pause-sub.png";
import * as React from 'react';
export default {
  CancelSub,
  PauseSub,
  React
};